import PropTypes from 'prop-types';

import getFormattedTime from '@utils/date/getFormattedTime';

function FormatHour({ timeFormat, value, children }) {
  const formattedHour = getFormattedTime(timeFormat, value);
  if (typeof children === 'function') return children(formattedHour);

  return formattedHour;
}

FormatHour.propTypes = {
  timeFormat: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.func,
};

export default FormatHour;
